/**
 * Created by Reda on 19.08.2024
 */
const MenuBarTextView = cc.Node.extend({
    ctor: function (item, options) {
        this.options = options || {};
        this._super();
        this.item = item;
        this.baseScale = 1;
        this.lastValue = item.getCurrentValue();
        MenuBarTextView.CheckNegative(item, this.lastValue);
        this.withTotal = this.lastValue.total !== undefined;

        this.amountText = cleverapps.UI.generateImageText("", cleverapps.styles.FONTS.MENUBAR_TEXT);
        this.addChild(this.amountText);

        this.setString(this.getString());
    },

    setString: function (string) {
        string = String(string);

        this.updateTotalIcon();

        if (this.item.totalIcon) {
            return;
        }

        this.updateAmountText(string);
        this.amountText.setPosition(this.width / 2, this.height / 2 + cleverapps.styles.MenuBarTextView.amountText.dy);
    },

    updateTotalIcon: function () {
        const styles = cleverapps.styles.MenuBarTextView;

        const visible = !!this.item.totalIcon;

        if (visible) {
            if (!this.totalIcon) {
                this.totalIcon = new cc.Sprite(this.item.totalIcon);
                this.totalIcon.setAlignment(styles.totalIcon);
                this.addChild(this.totalIcon);
            }
        } else if (this.totalIcon) {
            this.totalIcon.removeFromParent();
            delete this.totalIcon;
        }

        this.amountText.visible = !visible;
    },

    updateAmountText: function (string) {
        this.amountText.setString(string);

        if (!this.withTotal || cleverapps.styles.MenuBarTextView.noColoredText) {
            return;
        }

        const parts = string.split("/");

        const amount = +parts[0].trim();
        const total = +parts[1].trim();

        let amountColor = this.amountText.font.color || cleverapps.styles.COLORS.WHITE;

        if (amount >= total) {
            amountColor = cleverapps.styles.COLORS.GREEN;
        } else if (amount < total * 0.1) {
            amountColor = cleverapps.styles.COLORS.COLOR_RED;
        }

        let totalColor = this.amountText.font.color || cleverapps.styles.COLORS.WHITE;
        if (this.item.highlightTotal && this.item.highlightTotal()) {
            totalColor = cleverapps.styles.COLORS.COLOR_BONUS;
        }

        let color = amountColor;

        for (let index = 0; index < string.length; index++) {
            if (string[index] === "/") {
                color = totalColor;
                continue;
            }

            this.amountText.setLetterColor(index, color);
        }
    },

    valueToString: function (value) {
        if (this.withTotal) {
            return `${value.amount}/${value.total}`;
        }
        return `${value.amount}`;
    },

    getString: function () {
        return this.valueToString(this.lastValue);
    },

    animateAmountChange: function (amount, duration) {
        if (this.changeTextAction && !this.changeTextAction.isDone()) {
            this.stopAction(this.changeTextAction);
        }

        const isIncrement = amount > this.lastValue.amount;

        const disableIncSound = this.item.muteRegenerateLivesSound && this.item.muteRegenerateLivesSound() && (amount - this.lastValue.amount) === 1;

        if (!disableIncSound && isIncrement && this.item.incEffect) {
            cleverapps.effects.fire(typeof this.item.incEffect === "function" ? this.item.incEffect() : this.item.incEffect);
        }

        if (!isIncrement && this.item.decEffect) {
            cleverapps.effects.fire(typeof this.item.decEffect === "function" ? this.item.decEffect() : this.item.decEffect);
        }

        duration = isIncrement ? duration : 0.3;
        this.changeTextAction = this.runAction(
            new cc.Spawn(
                StandartAnimations.countTo(this, amount, { duration }),
                StandartAnimations.pulse(this, {
                    duration,
                    scaleRate: 1.1
                })
            )
        );
    },

    updateValue: function (duration) {
        const currentValue = this.item.getCurrentValue();
        MenuBarTextView.CheckNegative(this.item, currentValue);
        const amountDelta = currentValue.amount - this.lastValue.amount;
        const totalChanged = this.lastValue.total !== undefined && this.lastValue.total !== currentValue.total;

        let time = currentValue.time - (this.lastValue.time === undefined ? Date.now() : this.lastValue.time);
        if (time) {
            const value = Product.FormatTimePeriod(time);
            const title = Messages.get(value.title, value.toReplace);
            time = time > 0 ? `+${title}` : title;
        }
        const delta = time || amountDelta;

        if (amountDelta && !totalChanged) {
            this.animateAmountChange(currentValue.amount, duration);
        } else {
            if (totalChanged && this.changeTextAction && !this.changeTextAction.isDone()) {
                this.stopAction(this.changeTextAction);
            }
            this.setString(this.valueToString(currentValue));
        }
        this.lastValue = currentValue;
        return delta;
    },

    setDimensions: function (width, height) {
        this.amountText.setDimensions(width, height);
    }
});

MenuBarTextView.CheckNegative = function (item, value) {
    const name = item.getName();

    if (value.amount >= 0 || MenuBarTextView.reported[name]) {
        return;
    }
    MenuBarTextView.reported[name] = true;

    cleverapps.throwAsync({
        group: "MenuBarNegative",
        message: `${name.toUpperCase()} shown=${value.amount} ${cleverapps.pendingRewards.describe()}`
    });
};

MenuBarTextView.reported = {};

cleverapps.styles.MenuBarTextView = {
    totalIcon: {
        x: { align: "center", dx: -15 },
        y: { align: "center" }
    },

    amountText: {
        dy: 0
    }
};